module.exports = __webpack_public_path__ + "img/SERVICECOMBSERVICECENTER.8be2bf6d.png";